import React from "react"
import { BsStarFill } from "react-icons/bs"
import Ratings from "react-ratings-declarative"
import { format } from "date-fns"
import ReviewForm from "./review-form"

const Review = ({ productId, reviews, setReviews }) => {
  const fullReviews = reviews
    .map(x => {
      if (x.author_name !== "" && x.review !== "") {
        return x
      }
      return null
    })
    .filter(x => x !== null)

  const totalScore = reviews.reduce((a, b) => a + b.rating, 0) / reviews.length

  return (
    <div className="review">
      <div className="review__taste-score">
        {reviews.length > 0 && (
          <>
            <p
              className="review__taste-score--score-large is-hidden-touch"
              style={{ marginBottom: 5 }}
            >
              {totalScore.toFixed(1)}
            </p>
            <div className="is-hidden-touch" style={{ marginBottom: 15 }}>
              <Ratings rating={totalScore} widgetSpacings="5px">
                <Ratings.Widget
                  widgetDimension="20px"
                  widgetRatedColor="#1a1a38"
                />
                <Ratings.Widget
                  widgetDimension="20px"
                  widgetRatedColor="#1a1a38"
                />
                <Ratings.Widget
                  widgetDimension="20px"
                  widgetRatedColor="#1a1a38"
                />
                <Ratings.Widget
                  widgetDimension="20px"
                  widgetRatedColor="#1a1a38"
                />
                <Ratings.Widget
                  widgetDimension="20px"
                  widgetRatedColor="#1a1a38"
                />
              </Ratings>
            </div>
          </>
        )}
        <p className="review__taste-score--title">Taste Score</p>
        <p className="review__taste-score--sub-title">
          {reviews.length} reviews
        </p>
      </div>

      <div className="review__taste-score is-hidden-desktop">
        {reviews.length > 0 && (
          <>
            <p className="review__taste-score--score-large">
              {totalScore.toFixed(1)}
            </p>
            <Ratings rating={totalScore} widgetSpacings="5px">
              <Ratings.Widget
                widgetDimension="20px"
                widgetRatedColor="#1a1a38"
              />
              <Ratings.Widget
                widgetDimension="20px"
                widgetRatedColor="#1a1a38"
              />
              <Ratings.Widget
                widgetDimension="20px"
                widgetRatedColor="#1a1a38"
              />
              <Ratings.Widget
                widgetDimension="20px"
                widgetRatedColor="#1a1a38"
              />
              <Ratings.Widget
                widgetDimension="20px"
                widgetRatedColor="#1a1a38"
              />
            </Ratings>
          </>
        )}
      </div>
      <ReviewForm
        productId={productId}
        setReviews={setReviews}
        reviews={reviews}
      />
      <div className="review__two-cols">
        {fullReviews.map(review => {
          const date = review._createdAt
            ? format(new Date(review._createdAt), `LLL d, yyyy`)
            : format(Date.now(), `LLL d, yyyy`)
          return (
            <div key={review._id} className="review__comments">
              <strong>{review.author_name}</strong> - {date}
              <p style={{ display: "inline-flex", float: "right" }}>
                <span style={{ marginRight: 5 }}>{review.rating}</span>{" "}
                <BsStarFill style={{ color: "#1a1a38" }} />
              </p>
              <p style={{ marginTop: 10, lineHeight: 1.67 }}>{review.review}</p>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Review
